// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalWindow_header__2or9q","body":"ModalWindow_body__2N8kQ","footer":"ModalWindow_footer__2rv4R"};